/* eslint-disable import/prefer-default-export,react/forbid-prop-types */
import PropTypes from 'prop-types';
import React from 'react';
import { LTV_PERCENTAGES } from '../../../../../screens/Loans/constants';
import { mainStakingCurrency } from '../../../../../screens/Staking/constants';

export const LTVPercentSelect = ({
  ltv,
  onChangePercent,
  ltvPercentList,
  tierLevel,
  collateralCurrency,
}) => (
  <div className="d-flex flex-row-center w-100 rounded-4 mt-3 bg-lighter border border-shadow">
    {Object.keys(ltvPercentList).map((key) => (
      <button
        disabled={
          (tierLevel?.userStakingTier &&
            tierLevel?.userStakingTier?.stableloan_ltv_interest_free &&
            LTV_PERCENTAGES[key] < tierLevel?.userStakingTier?.stableloan_ltv_interest_free &&
            collateralCurrency !== mainStakingCurrency) ||
          (collateralCurrency === mainStakingCurrency &&
            LTV_PERCENTAGES[key] > LTV_PERCENTAGES.interest_rate_ltv_10)
        }
        key={key}
        type="button"
        style={{ height: '2.5rem' }}
        className={`toggle-item ${ltv === key && 'active'} btn w-100 p-2 rounded-3 bg-lighter`}
        onClick={() => onChangePercent(key)}>
        {`${ltvPercentList[key]}%`}
      </button>
    ))}
  </div>
);

LTVPercentSelect.propTypes = {
  ltv: PropTypes.string.isRequired,
  onChangePercent: PropTypes.func.isRequired,
  ltvPercentList: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  tierLevel: PropTypes.object.isRequired,
  collateralCurrency: PropTypes.string.isRequired,
};
